export enum Field {
    EMAIL = "email",
    PHONE = "phone"
}